import { Injectable } from '@angular/core'
import { CommonService } from '../../../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class QuoteReviewService {
  code: any
  constructor(public commonService: CommonService) {}
  submitQuote(userType, cartId, ftqFlag) {
    let lastPart = `createQuote?`
    const params = ['users', userType, 'rfqcart', cartId]
    lastPart += `ftq=${ftqFlag}`
    params.push(lastPart)
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData(apiUrl)
  }
  setCode(code) {
    this.code = code
  }
  getCode() {
    return this.code
  }

  downloadQuotePdf(userType, id) {
    const params = [
      'users',
      userType,
      'rfqcart',
      id,
      'quote',
      'downloadReviewQuotePDF',
    ]
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData_PDF(apiUrl)
  }

  downloadQuoteCnfPdf(userType, id) {
    const params = ['users', userType, 'rfqcart', id, 'downloadQuotePDF']
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData_PDF(apiUrl)
  }
}
